import React from 'react';
import moment from 'moment';

const DateTime = React.createClass({

  propTypes: {
    ts: React.PropTypes.number
  },

  format: function (ts) {
    return;
  },

  render: function () {
    let s = '', timeStamp = this.props.ts;

    if (timeStamp > 0) {
      if (timeStamp < 9999999999) {
        timeStamp *= 1000;
      }
      if (timeStamp % 1000 === 0) {
        s = moment.utc(timeStamp).format("YYYY-MM-DD HH:mm:ss");
      } else {
        s = moment.utc(timeStamp).format("YYYY-MM-DD HH:mm:ss.SSS");
      }
    }

    return (
      <span className="datetime">{s}</span>
    );
  }
});

export default DateTime;



// WEBPACK FOOTER //
// ./src/js/Component/DateTime.jsx